import React from 'react';
import { Box } from '@mui/material';

export const ReadOnlyPanel: React.FC<{ children: React.ReactNode }> = ({ children }) => (
    <Box
        sx={{
            backgroundColor: '#F8FAFC',
            border: '1px solid #E2E8F0',
            borderRadius: '10px',
            p: 2.5,
            display: 'flex',
            gap: 2,
            flexWrap: 'wrap',
        }}
    >
        {children}
    </Box>
);
